module.exports = __webpack_public_path__ + "static/media/central-region-states-sm.696e8cb6.png";